"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var logs_1 = require("@ledgerhq/logs");
var types_1 = require("./types");
var buildBigNumber_1 = require("./buildBigNumber");
var promise_1 = require("../promise");
var portfolio_1 = require("../portfolio");
var invariant_1 = __importDefault(require("invariant"));
var getAccountBalanceHistory = function (coreA, range) { return __awaiter(void 0, void 0, void 0, function () {
    var dates, conf, period, to, fromISO, toISO, rawBalances, balances, balanceHistory;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dates = (0, portfolio_1.getDates)(range);
                conf = (0, portfolio_1.getPortfolioRangeConfig)(range);
                period = types_1.TimePeriod[conf.granularityId];
                (0, logs_1.log)("getAccountBalanceHistory", "calc for range=" + range + " with " + dates.length + " datapoint");
                to = new Date(conf.startOf(new Date()).getTime() + conf.increment - 1);
                fromISO = new Date(dates[0].valueOf() - conf.increment).toISOString();
                toISO = to.toISOString();
                return [4 /*yield*/, coreA.getBalanceHistory(fromISO, toISO, period)];
            case 1:
                rawBalances = _a.sent();
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(5, rawBalances, buildBigNumber_1.libcoreAmountToBigNumber)];
            case 2:
                balances = _a.sent();
                (0, invariant_1["default"])(balances.length === dates.length, "Mismatch in sizes dates/balance");
                balanceHistory = balances.map(function (value, i) { return ({
                    date: dates[i],
                    value: value
                }); });
                (0, logs_1.log)("getAccountBalanceHistory", "DONE. calc for range=" +
                    range +
                    ". " +
                    balanceHistory.length +
                    " datapoint. period=" +
                    period +
                    " range: [" +
                    fromISO +
                    ", " +
                    toISO +
                    "]");
                return [2 /*return*/, balanceHistory];
        }
    });
}); };
exports["default"] = getAccountBalanceHistory;
//# sourceMappingURL=getAccountBalanceHistory.js.map